const lightbox = document.getElementById('lightbox');
const lightboxWrapper = document.querySelector('.lightbox-container');

class Lightbox {
    constructor() {
        this.images = document.querySelectorAll('img.lightbox');
    }

    init() {
        if (this.images) {
            this.updateImageTag();
            this.clickEvents();
        }
    }

    clickEvents() {
        this.openLightbox();
        if (lightbox) this.closeLightbox();
    }
    
    openLightbox() {
        this.images.forEach( img => {
            const url = img.getAttribute('src');
            const caption = img.getAttribute('caption');

            img.addEventListener('click', () => {
                this.show();
                this.createImg(url);
                
                if (caption) this.createFigcaption(caption);
            })
        });
    }
    
    closeLightbox() {
        lightbox.addEventListener('click', (e) => {
            if (e.target.nodeName !== 'IMG') {
                this.hide();
            }
        })
    }

    show() {
        lightbox.classList.remove('opacity-0');
        lightbox.classList.remove('disactive');

        lightbox.classList.add('active');

        this.disableScroll();
    }

    hide() {
        lightbox.classList.add('disactive');
        document.body.classList.remove('overflow-y-scroll', 'fixed');

        this.enableScroll()
        
        setTimeout( () => {
            lightbox.classList.remove('active');
            this.removeImg();
            this.removeFigcaption();
        }, 200);
    }

    updateImageTag() {
        this.images.forEach( img => {
            this.addIcon(img);
            this.setWidth(img);
        })
    }

    createImg(url) {
        const img = document.createElement('img');
        lightboxWrapper.append(img);
        img.setAttribute('src', url);
    }

    createFigcaption(caption) {
        const figcaption = document.createElement('figcaption');
        lightboxWrapper.append(figcaption);
        figcaption.textContent = caption;
    }

    removeImg() {
        const img = lightboxWrapper.querySelector('img');
        if (img) img.remove();
    }

    removeFigcaption() {
        const figcaption = lightboxWrapper.querySelector('figcaption');
        if (figcaption) figcaption.remove();
    }

    enableScroll() {
        const scrollY = document.body.style.top;
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    disableScroll() {
        document.body.style.top = `-${window.scrollY}px`;
        document.body.classList.add('overflow-y-scroll', 'fixed');
    }

    addIcon(img) {
        const div = document.createElement('div')
        div.classList.add('lightbox-wrapper');
        img.parentNode.insertBefore(div,img)
        div.append(img)
    }

    setWidth(img) {
        const width = img.dataset.width;
        img.parentNode.style.width = width + "%";
    }
}

export default new Lightbox()